const EMPTY_OLD_VALUE = '( not set )';

const isEmptyValue = (value) => value === null || value === undefined || value === '';

export default {
  methods: {
    regionalMappingOldValueExists(variable) {
      if (this.data == null || this.data.old_value == null) {
        return false;
      }

      if (!Object.prototype.hasOwnProperty.call(this.data.old_value, variable)) {
        return false;
      }

      const oldValue = this.data.old_value[variable];
      const newValue = this.data[variable];

      if (isEmptyValue(oldValue)) {
        return !isEmptyValue(newValue);
      }

      return oldValue !== newValue;
    },
    regionalMappingOldValueText(variable) {
      if (this.data == null || this.data.old_value == null) {
        return '';
      }

      const oldValue = this.data.old_value[variable];
      if (isEmptyValue(oldValue)) {
        return EMPTY_OLD_VALUE;
      }

      return oldValue;
    },
  },
};
